import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ScrollReveal } from '../components/ScrollReveal';
import { CTAButton } from '../components/CTAButton';
import { Sparkles, Target, Users, Rocket, Award, Briefcase, ChevronDown, Quote, CheckCircle2, TrendingUp, Globe, MessageCircle, Zap, ShieldCheck } from 'lucide-react';
const WHATSAPP_URL = 'https://wa.me/1234567890';
export function MarcaPersonal() {
  return <main className="min-h-screen bg-[#050510] text-gray-300 selection:bg-cyan-500/30 selection:text-cyan-100" data-id="element-784">
      <Navbar data-id="element-785" />

      {/* 1. HERO — EL PODER DE UNA MARCA */}
      <section className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-id="element-786">
        <div className="absolute inset-0 z-0" data-id="element-787">
          <div className="absolute inset-0 bg-gradient-to-b from-[#050510] via-[#050510]/90 to-[#0a0a1f]" data-id="element-788" />
          <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-789" />
          <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-cyan-500/10 rounded-full blur-[120px]" data-id="element-790" />
          <div className="absolute bottom-1/4 right-1/4 w-[600px] h-[600px] bg-purple-600/10 rounded-full blur-[150px]" data-id="element-791" />
        </div>

        <div className="relative z-10 container mx-auto px-4 max-w-5xl text-center" data-id="element-792">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8 backdrop-blur-md" data-id="element-793">
            <Sparkles className="w-4 h-4 text-cyan-400" data-id="element-794" />
            <span className="text-sm font-semibold text-cyan-100 tracking-wide uppercase" data-id="element-795">
              El Poder de una Marca
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-5xl md:text-7xl lg:text-8xl font-extrabold leading-[1.1] tracking-tight mb-8" data-id="element-796">
            CONSTRUYE UNA MARCA CON <br className="hidden md:block" data-id="element-797" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400" data-id="element-798">
              PROPÓSITO Y PODER
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-xl md:text-2xl text-gray-300 mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-799">
            Hoy vivimos en una economía de atención donde las personas no solo
            compran productos.{' '}
            <strong className="text-white" data-id="element-800">
              Siguen historias, identidades y valores.
            </strong>
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="text-lg text-gray-400 mb-12 max-w-2xl mx-auto" data-id="element-801">
            Una marca bien construida te permite generar autoridad, abrir
            oportunidades, monetizar tu conocimiento y crear un impacto real en
            el mundo. Hoy cualquier persona puede convertirse en una marca, pero
            no cualquiera logra posicionarse estratégicamente.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="mb-16" data-id="element-802">
            <CTAButton text="Hablar por WhatsApp" href={WHATSAPP_URL} size="lg" className="min-w-[300px]" data-id="element-803" />
          </motion.div>

          {/* Seth Godin Quote */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="max-w-3xl mx-auto" data-id="element-804">
            <div className="glass-card p-8 rounded-2xl border-l-4 border-l-cyan-500 relative text-left" data-id="element-805">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-cyan-500/20" data-id="element-806" />
              <p className="text-lg md:text-xl text-gray-300 italic mb-4 relative z-10" data-id="element-807">
                "Una marca es el conjunto de expectativas, recuerdos, historias
                y relaciones que, en conjunto, explican la decisión de un
                consumidor de elegir un producto o servicio sobre otro."
              </p>
              <p className="text-cyan-400 font-semibold" data-id="element-808">
                — Seth Godin, Economista y Autor
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 0.8
      }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-gray-500" data-id="element-809">
          <span className="text-xs tracking-widest uppercase" data-id="element-810">
            Descubre cómo
          </span>
          <motion.div animate={{
          y: [0, 6, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'easeInOut'
        }} data-id="element-811">
            <ChevronDown className="w-5 h-5" data-id="element-812" />
          </motion.div>
        </motion.div>
      </section>

      {/* 2. ¿QUÉ ES REALMENTE UNA MARCA? */}
      <section className="py-24 md:py-32 px-4 bg-[#0a0a1f] relative" data-id="element-813">
        <div className="container mx-auto max-w-5xl" data-id="element-814">
          <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-815">
            <ScrollReveal direction="right" data-id="element-816">
              <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-817">
                ¿Qué es realmente <br data-id="element-818" />
                <span className="text-cyan-400" data-id="element-819">una marca?</span>
              </h2>
              <p className="text-xl text-gray-300 mb-6" data-id="element-820">
                Una marca no es solo un logo o una página web.{' '}
                <strong className="text-white" data-id="element-821">Una marca es percepción.</strong>
              </p>
              <p className="text-lg text-gray-400 mb-8" data-id="element-822">
                Es la forma en que las personas te recuerdan cuando no estás
                presente. El objetivo real de una marca es generar confianza.
              </p>

              <div className="space-y-4 mb-10" data-id="element-823">
                <h3 className="text-white font-semibold text-lg" data-id="element-824">
                  Una marca bien estructurada integra:
                </h3>
                {['Identidad', 'Narrativa', 'Valor', 'Posicionamiento', 'Consistencia'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-825">
                    <CheckCircle2 className="w-5 h-5 text-cyan-400 flex-shrink-0" data-id="element-826" />
                    <span className="text-gray-300" data-id="element-827">{item}</span>
                  </div>)}
              </div>

              <CTAButton text="Quiero construir mi marca" href={WHATSAPP_URL} size="md" data-id="element-828" />
            </ScrollReveal>

            <ScrollReveal direction="left" delay={0.2} data-id="element-829">
              <div className="glass-card p-8 md:p-10 rounded-3xl border-l-4 border-l-purple-500 relative" data-id="element-830">
                <Quote className="absolute top-8 right-8 w-12 h-12 text-purple-500/20" data-id="element-831" />
                <p className="text-xl md:text-2xl text-gray-200 italic mb-6 leading-relaxed relative z-10" data-id="element-832">
                  "Una marca sólida se construye cuando una empresa o persona
                  logra ocupar un espacio claro y diferenciador en la mente del
                  consumidor."
                </p>
                <div className="flex items-center gap-4" data-id="element-833">
                  <div className="w-12 h-12 rounded-full bg-purple-500/20 flex items-center justify-center" data-id="element-834">
                    <Target className="w-6 h-6 text-purple-400" data-id="element-835" />
                  </div>
                  <div data-id="element-836">
                    <p className="text-purple-400 font-bold text-lg" data-id="element-837">
                      Philip Kotler
                    </p>
                    <p className="text-sm text-gray-400" data-id="element-838">
                      Padre del marketing moderno
                    </p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* 3. CREACIÓN DE MARCA PERSONAL */}
      <section className="py-24 md:py-32 px-4 bg-gradient-to-b from-[#0a0a1f] to-[#050510]" data-id="element-839">
        <div className="container mx-auto max-w-5xl" data-id="element-840">
          <ScrollReveal className="text-center mb-16" data-id="element-841">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-842">
              La Era de la{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400" data-id="element-843">
                Marca Personal
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-844">
              Las redes sociales, las plataformas digitales y la economía del
              conocimiento han permitido que cualquier persona pueda compartir
              su experiencia, su visión y su talento con el mundo.
            </p>
          </ScrollReveal>

          <div className="grid lg:grid-cols-12 gap-12 items-center mb-16" data-id="element-845">
            <div className="lg:col-span-5" data-id="element-846">
              <ScrollReveal direction="right" data-id="element-847">
                <div className="glass-card p-8 rounded-3xl border-l-4 border-l-pink-500 relative" data-id="element-848">
                  <Quote className="absolute top-6 right-6 w-10 h-10 text-pink-500/20" data-id="element-849" />
                  <p className="text-xl text-gray-200 italic mb-6 relative z-10" data-id="element-850">
                    "Hoy la marca personal es uno de los activos más valiosos
                    que una persona puede construir."
                  </p>
                  <p className="text-pink-400 font-bold" data-id="element-851">— Gary Vaynerchuk</p>
                </div>
              </ScrollReveal>
            </div>

            <div className="lg:col-span-7" data-id="element-852">
              <div className="grid sm:grid-cols-2 gap-6" data-id="element-853">
                {[{
                title: 'Posicionarse como experto',
                icon: Award
              }, {
                title: 'Generar comunidad',
                icon: Users
              }, {
                title: 'Crear oportunidades de negocio',
                icon: Briefcase
              }, {
                title: 'Monetizar conocimiento',
                icon: TrendingUp
              }, {
                title: 'Inspirar a otras personas',
                icon: Sparkles
              }].map((item, i) => <ScrollReveal key={i} delay={0.1 * i} direction="up" data-id="element-854">
                    <div className="p-6 rounded-2xl bg-white/5 border border-white/5 hover:border-purple-500/30 transition-colors flex items-start gap-4" data-id="element-855">
                      <item.icon className="w-6 h-6 text-purple-400 shrink-0 mt-1" data-id="element-856" />
                      <span className="text-gray-200 font-medium" data-id="element-857">
                        {item.title}
                      </span>
                    </div>
                  </ScrollReveal>)}
              </div>
            </div>
          </div>

          <ScrollReveal delay={0.4} data-id="element-858">
            <div className="glass-card p-8 md:p-12 rounded-3xl border-purple-500/20 relative overflow-hidden text-center max-w-4xl mx-auto" data-id="element-859">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-purple-500/5 rounded-full blur-[100px]" data-id="element-860" />
              <p className="text-lg md:text-xl text-gray-300 mb-6 relative z-10" data-id="element-861">
                Muchas personas aún no han encontrado exactamente cuál es su
                pasión o propósito. Sin embargo, al comenzar a desarrollar su
                marca personal, compartir valor y documentar su camino,{' '}
                <strong data-id="element-862">comienzan a descubrirlo</strong>.
              </p>
              <p className="text-lg md:text-xl text-gray-300 mb-8 relative z-10" data-id="element-863">
                Este proceso activa algo muy poderoso:{' '}
                <strong className="text-white" data-id="element-864">
                  la ley natural de dar y recibir
                </strong>
                . Cuando aportas valor genuino a otros, inevitablemente generas
                impacto y posicionamiento.
              </p>
              <div className="relative z-10" data-id="element-865">
                <CTAButton text="Empezar mi camino" href={WHATSAPP_URL} size="md" data-id="element-866" />
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* 4. EJEMPLOS DE MARCA PERSONAL */}
      <section className="py-24 md:py-32 px-4 bg-[#050510] relative border-y border-white/5" data-id="element-867">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-cyan-500/5 rounded-full blur-[150px] pointer-events-none" data-id="element-868" />

        <div className="container mx-auto max-w-6xl relative z-10" data-id="element-869">
          <ScrollReveal className="text-center mb-16" data-id="element-870">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-871">
              Marcas Personales que se <br data-id="element-872" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500" data-id="element-873">
                Convirtieron en Imperios
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-874">
              Muchas de las marcas más poderosas del mundo nacieron a partir de
              la marca personal de una persona. Entendieron que la marca
              personal es una plataforma.
            </p>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-875">
            {[{
            name: 'Kim Kardashian',
            desc: 'Transformó su presencia mediática en una de las marcas personales más influyentes del mundo, creando empresas multimillonarias en moda, belleza y lifestyle.',
            color: 'from-pink-500 to-rose-500'
          }, {
            name: 'Kylie Jenner',
            desc: 'Construyó una de las compañías de cosméticos más exitosas del mundo a partir de su identidad personal.',
            color: 'from-purple-500 to-indigo-500'
          }, {
            name: 'Rihanna',
            desc: 'Transformó su influencia cultural en una marca global con Fenty Beauty, redefiniendo la industria de la belleza con inclusión y autenticidad.',
            color: 'from-cyan-500 to-blue-500'
          }, {
            name: 'Oprah Winfrey',
            desc: 'Convirtió su historia personal, su voz y su visión en una de las plataformas mediáticas más influyentes del planeta.',
            color: 'from-amber-500 to-orange-500'
          }].map((person, i) => <ScrollReveal key={i} delay={0.1 * i} direction="up" data-id="element-876">
                <div className="glass-card p-8 rounded-3xl relative overflow-hidden group" data-id="element-877">
                  <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r ${person.color}`} data-id="element-878" />
                  <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${person.color} opacity-5 rounded-bl-full transition-opacity group-hover:opacity-10`} data-id="element-879" />

                  <h3 className="text-2xl font-bold text-white mb-4" data-id="element-880">
                    {person.name}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-881">{person.desc}</p>
                </div>
              </ScrollReveal>)}
          </div>

          <ScrollReveal delay={0.4} className="text-center" data-id="element-882">
            <div className="inline-block p-1 rounded-full bg-gradient-to-r from-cyan-500 to-purple-600 mb-8" data-id="element-883">
              <div className="px-8 py-4 rounded-full bg-[#050510]" data-id="element-884">
                <p className="text-lg font-medium text-white" data-id="element-885">
                  Desde esa plataforma puedes lanzar productos, servicios,
                  movimientos e incluso impacto cultural.
                </p>
              </div>
            </div>
            <div data-id="element-886">
              <CTAButton text="Construir mi plataforma" href={WHATSAPP_URL} size="md" data-id="element-887" />
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* 5. EL LANZAMIENTO DE UN PRODUCTO O SERVICIO */}
      <section className="py-24 md:py-32 px-4 bg-[#0a0a1f] relative" data-id="element-888">
        <div className="container mx-auto max-w-5xl" data-id="element-889">
          <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-890">
            <ScrollReveal direction="right" data-id="element-891">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-892">
                El lanzamiento de un <br data-id="element-893" />
                <span className="text-cyan-400" data-id="element-894">Producto o Servicio</span>
              </h2>
              <p className="text-xl text-gray-300 mb-6" data-id="element-895">
                Una marca sólida no solo comunica, también{' '}
                <strong className="text-white" data-id="element-896">crea valor real</strong>.
              </p>
              <p className="text-lg text-gray-400 mb-8" data-id="element-897">
                Un producto o servicio debe resolver un problema, facilitar la
                vida de las personas, o aportar bienestar, conocimiento o
                transformación.
              </p>

              <div className="p-6 rounded-2xl bg-white/5 border border-white/10 mb-8" data-id="element-898">
                <p className="text-gray-300 mb-2" data-id="element-899">
                  Una marca que conecta con propósito logra generar:
                </p>
                <ul className="space-y-2 mt-4" data-id="element-900">
                  <li className="flex items-center gap-2 text-cyan-100" data-id="element-901">
                    <ShieldCheck className="w-5 h-5 text-cyan-500" data-id="element-902" />{' '}
                    Comunidades más fuertes
                  </li>
                  <li className="flex items-center gap-2 text-cyan-100" data-id="element-903">
                    <ShieldCheck className="w-5 h-5 text-cyan-500" data-id="element-904" /> Clientes
                    más fieles
                  </li>
                </ul>
              </div>

              <CTAButton text="Lanzar mi producto" href={WHATSAPP_URL} size="md" data-id="element-905" />
            </ScrollReveal>

            <ScrollReveal direction="left" delay={0.2} data-id="element-906">
              <div className="glass-card p-8 md:p-10 rounded-3xl border-l-4 border-l-cyan-500 relative" data-id="element-907">
                <Quote className="absolute top-8 right-8 w-12 h-12 text-cyan-500/20" data-id="element-908" />
                <p className="text-xl md:text-2xl text-gray-200 italic mb-6 leading-relaxed relative z-10" data-id="element-909">
                  "Las personas no compran lo que haces, compran por qué lo
                  haces."
                </p>
                <div className="flex items-center gap-4" data-id="element-910">
                  <div className="w-12 h-12 rounded-full bg-cyan-500/20 flex items-center justify-center" data-id="element-911">
                    <Globe className="w-6 h-6 text-cyan-400" data-id="element-912" />
                  </div>
                  <div data-id="element-913">
                    <p className="text-cyan-400 font-bold text-lg" data-id="element-914">
                      Simon Sinek
                    </p>
                    <p className="text-sm text-gray-400" data-id="element-915">Autor y Estratega</p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* 6. NUESTRA METODOLOGÍA COMO AGENCIA */}
      <section className="py-24 md:py-32 px-4 bg-gradient-to-b from-[#0a0a1f] to-[#050510]" data-id="element-916">
        <div className="container mx-auto max-w-5xl" data-id="element-917">
          <ScrollReveal className="text-center mb-16" data-id="element-918">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-919">
              Nuestra Metodología <br data-id="element-920" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-cyan-400" data-id="element-921">
                Como Agencia
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-922">
              Aplicamos principios estratégicos de marketing para ayudar a
              empresarios, profesionales y emprendedores a construir marcas que
              generen resultados reales.
            </p>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-923">
            {[{
            step: '01',
            title: 'Definición estratégica de marca'
          }, {
            step: '02',
            title: 'Identificación del público objetivo'
          }, {
            step: '03',
            title: 'Desarrollo de narrativa de marca'
          }, {
            step: '04',
            title: 'Creación de contenido estratégico'
          }, {
            step: '05',
            title: 'Producción audiovisual profesional'
          }, {
            step: '06',
            title: 'Diseño de productos con valor real'
          }, {
            step: '07',
            title: 'Lanzamiento digital'
          }, {
            step: '08',
            title: 'Campañas de publicidad y posicionamiento'
          }].map((item, i) => <ScrollReveal key={i} delay={0.05 * i} direction="up" data-id="element-924">
                <div className="p-6 rounded-2xl bg-white/5 border border-white/5 hover:border-cyan-500/30 transition-all h-full relative overflow-hidden group" data-id="element-925">
                  <div className="absolute -right-4 -top-4 text-6xl font-black text-white/5 group-hover:text-cyan-500/10 transition-colors" data-id="element-926">
                    {item.step}
                  </div>
                  <h3 className="text-lg font-bold text-gray-200 relative z-10 mt-4" data-id="element-927">
                    {item.title}
                  </h3>
                </div>
              </ScrollReveal>)}
          </div>

          <ScrollReveal delay={0.4} className="text-center" data-id="element-928">
            <p className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-929">
              No se trata solo de marketing.
              <br data-id="element-930" />
              <span className="text-cyan-400" data-id="element-931">
                Se trata de construir un ecosistema de marca.
              </span>
            </p>
            <CTAButton text="Conocer la metodología" href={WHATSAPP_URL} size="lg" data-id="element-932" />
          </ScrollReveal>
        </div>
      </section>

      {/* 7. POSICIONAMIENTO Y AUTORIDAD */}
      <section className="py-24 md:py-32 px-4 bg-[#050510] relative border-y border-white/5" data-id="element-933">
        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-purple-600/5 rounded-full blur-[150px] pointer-events-none" data-id="element-934" />

        <div className="container mx-auto max-w-5xl" data-id="element-935">
          <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-936">
            <ScrollReveal direction="right" className="order-2 md:order-1" data-id="element-937">
              <div className="glass-card p-8 md:p-10 rounded-3xl border-l-4 border-l-orange-500 relative" data-id="element-938">
                <Quote className="absolute top-8 right-8 w-12 h-12 text-orange-500/20" data-id="element-939" />
                <p className="text-xl md:text-2xl text-gray-200 italic mb-6 leading-relaxed relative z-10" data-id="element-940">
                  "Las marcas que logran posicionarse son aquellas que cuentan
                  historias claras donde el cliente es el protagonista y la
                  marca se convierte en la guía."
                </p>
                <div className="flex items-center gap-4" data-id="element-941">
                  <div className="w-12 h-12 rounded-full bg-orange-500/20 flex items-center justify-center" data-id="element-942">
                    <Zap className="w-6 h-6 text-orange-400" data-id="element-943" />
                  </div>
                  <div data-id="element-944">
                    <p className="text-orange-400 font-bold text-lg" data-id="element-945">
                      Donald Miller
                    </p>
                    <p className="text-sm text-gray-400" data-id="element-946">Autor de StoryBrand</p>
                  </div>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal direction="left" className="order-1 md:order-2" data-id="element-947">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-948">
                Posicionamiento y <br data-id="element-949" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-500" data-id="element-950">
                  Autoridad
                </span>
              </h2>
              <p className="text-xl text-gray-300 mb-6" data-id="element-951">
                Cuando una marca está bien construida, ocurre algo muy poderoso.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-952">
                {['Las oportunidades comienzan a aparecer.', 'La credibilidad aumenta.', 'Las personas confían.', 'Tu voz comienza a tener influencia dentro de tu industria.'].map((text, i) => <li key={i} className="flex items-center gap-3 text-lg text-gray-300" data-id="element-953">
                    <div className="w-2 h-2 rounded-full bg-orange-500 shrink-0" data-id="element-954" />
                    {text}
                  </li>)}
              </ul>

              <CTAButton text="Posicionar mi marca" href={WHATSAPP_URL} size="md" data-id="element-955" />
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* 8. FINAL CTA — CONSTRUYE UNA MARCA QUE DEJE HUELLA */}
      <section className="py-32 px-4 relative overflow-hidden flex items-center justify-center min-h-[70vh]" data-id="element-956">
        <div className="absolute inset-0 bg-gradient-to-b from-[#050510] to-[#0a0a1f]" data-id="element-957" />
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-958" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-500/10 rounded-full blur-[150px] pointer-events-none" data-id="element-959" />

        <div className="container mx-auto max-w-4xl relative z-10 text-center" data-id="element-960">
          <ScrollReveal data-id="element-961">
            <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight" data-id="element-962">
              CONSTRUYE UNA MARCA <br data-id="element-963" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500" data-id="element-964">
                QUE DEJE HUELLA
              </span>
            </h2>
          </ScrollReveal>

          <ScrollReveal delay={0.2} data-id="element-965">
            <p className="text-xl md:text-2xl text-gray-300 mb-6 leading-relaxed max-w-3xl mx-auto" data-id="element-966">
              Muchas personas tienen talento, conocimiento y propósito, pero aún
              no han construido la plataforma que les permita compartirlo con el
              mundo.
            </p>
            <p className="text-2xl md:text-3xl font-bold text-white mb-12" data-id="element-967">
              Una marca bien construida puede convertirse en esa plataforma.
            </p>
          </ScrollReveal>

          <ScrollReveal delay={0.4} data-id="element-968">
            <div className="flex flex-col items-center gap-6" data-id="element-969">
              <CTAButton text="Comenzar mi marca ahora" href={WHATSAPP_URL} size="lg" className="text-xl px-12 py-5" data-id="element-970" />
            </div>
          </ScrollReveal>
        </div>
      </section>

      <Footer data-id="element-971" />
    </main>;
}